import {api} from "../app/api.js";

export class KerdoivService
{
  model;

  constructor(model)
  {
    this.model = model;

    this.list = localStorage.kerdoiv && JSON.parse(localStorage.kerdoiv) || [];

  }

  async SendAjánlatKérés() {
    
    // this.list.push(this.model);
    // localStorage.kerdoiv = JSON.stringify(this.list);
    //
    return api.post('Kerdoiv', 'SendAjánlatKérés', this.model);
  }

  async CheckExistingAjánlatKérésForEmail() {
    return api.get('Kerdoiv', 'CheckExistingAjánlatKérésForEmail', {email: this.model.Email});
  }

  async GetCaptcha() {
    return api.get('Kerdoiv', 'GetCaptcha');
  }

  async VerifyCaptcha(captchaResponse) {
    return api.get('Kerdoiv', 'VerifyCaptcha', { captchaResponse });
  }
}